import { StreamData } from 'types/streamData'
import { getFullDisplay } from 'utils/timeZoneUtil'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const fullDateTimeResolver: FieldResolver = (metadata: Metadata) => {
  let fullDateTime = ''
  const isDeleted = metadata.isDeleted()
  const dateTime = metadata.getDateTime()

  if (!isDeleted && dateTime) {
    fullDateTime = getFullDisplay(dateTime, metadata.getTimeZone()!)
  }

  return { fullDateTime } as StreamData
}

export default fullDateTimeResolver
